<template>
  <div class="deals">
    <div class="tableFilters">
      <div class="filtersInner">
        <div class="control">
          <div class="select">
            <select v-model="tableData.length" @change="callFunction(data)">
              <option v-for="(records, index) in perPage" :key="index" :value="records">{{ records }}
              </option>
            </select>
          </div>
        </div>
        <div class="inputcontainer">
          <input class="input" type="text" v-model.trim="tableData.search" placeholder="Suchen..."
                 @input="handleInput($event)"
          >
          <div v-if="loading" class="icon-container">
            <i class="loader"></i>
          </div>
        </div>
        <div v-if="data === 'getDeals' && currentBreakpoint === 'lg'" class="control">
          <status-filter @statusFilter="filterStatus"></status-filter>
        </div>
        <div v-if="$attrs.deallist" class="control"
             style="margin-left: 1rem; position: relative; top:1px;align-items: center;">
          <DeallistFilter style="display: inline-block;" @applyFilter="$emit('applyFilter')"
                          v-bind="$attrs"></DeallistFilter>
          <div v-if="displayDeallistFilter.length > 0" class="deallistFilter" style="margin-left:1rem;">
            <InfoBubble v-for="(value, j) in displayDeallistFilter"
                        :key="'finalFilter_'+j" @bubbleDeleted="filterValueDeleted($event, finalFilter[j])"
                        :is-filled="false" :value="value" color="purple"></InfoBubble>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data === 'getDeals' && currentBreakpoint !== 'lg'" class="mobileStatusFilter">
      <status-filter class="mobileStatus" @statusFilter="filterStatus"></status-filter>
    </div>
    <datatable :data-loading="dataLoading" class="table" :key="key" :rows="deals" :columns="columns"
               :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" :transformers="transformers"
               @rowClicked="emitRowClicked" :selectableRows="selectableRows" v-bind="$attrs"
               @selected="$emit('selected', $event)" @cbx_all="setCBXall"
               @action:delete="$emit('action:delete', $event)">
    </datatable>
    <pagination :pagination="pagination"
                @prev="callFunction(data, pagination.prevPageUrl)"
                @next="callFunction(data, pagination.nextPageUrl)">
    </pagination>
  </div>
</template>

<script>
import Datatable from './Datatable.vue';
import Utils from "../../scripts/utils";
import Pagination from './Pagination.vue';
import {RepositoryFactory} from "@/scripts/RepositoryFactory";
import StatusFilter from "../filter/StatusFilter";
import DeallistFilter from "@/components/filter/DeallistFilter";
import InfoBubble from "@/components/inputs/InfoBubble";

const DealRepository = RepositoryFactory.get('deals');
//const PresetRepository = RepositoryFactory.get('presets');
export default {
  components: {InfoBubble, DeallistFilter, StatusFilter, datatable: Datatable, pagination: Pagination},
  props: {
    columns: Array,
    preset: Number,
    data: String,
    searchData: Object,
    transformers: {
      $each: {
        validator: function (value) {
          return value.propName && value.transform
        }
      },
    },
    tableLength: {
      type: Number,
      default: 10
    },
    selectableRows: {type: Boolean, default: false},
    saveSearch: {
      type: Boolean,
      default: false //save search even after reload
    }
  },
  data() {
    let sortOrders = {};

    this.columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    let length = this.tableLength;
    let index = this.getIndex(this.columns, 'name', 'brutto_revenue');
    return {
      key: 1,
      deals: [],
      loading: false,
      dataLoadingCount: 0,
      dataLoading: false,
      sortKey: index !== -1 ? 'brutto_revenue' : 'status',
      sortOrders: sortOrders,
      statusFilter: [],
      perPage: ['10', '25', '50', '100'],
      tableData: {
        draw: 0,
        length: length,
        search: '',
        column: index !== -1 ? index : 0,
        dir: 'desc',
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      loadingCount: 0,
      currentBreakpoint: null,
      cbx_all: false,
    }
  },
  mounted() {
    if (this.data === 'getDeals') {
      if (this.$route.name === 'deals') {
        this.fetchItems(sessionStorage.getItem('tableFilterAll'));
      } else if (this.$route.name === 'mydealsall') {
        this.fetchItems(sessionStorage.getItem('tableFilterMy'));
      } else if (this.$route.name === 'mydeals') {
        this.fetchItems(sessionStorage.getItem('tableFilterPreset'));
      }
    }

    this.$root.$on('rangeChange', this.updateRange);
    if (this.data !== 'getDeals' || this.$route.name !== 'mydeals' || (this.preset && this.$route.name === 'mydeals')) {
      this[this.data]();
    }
    this.$root.$on('dateChange', this.updateRange);
  },
  beforeDestroy() {
    this.$root.$off('rangeChange', this.updateRange);
    this.$root.$off('dateChange', this.updateRange);
  },
  created() {
    this.currentBreakpoint = Utils.getCurrentBreakpoint();
    window.addEventListener('resize', () => {
      this.currentBreakpoint = Utils.getCurrentBreakpoint();
    });
  },
  computed: {
    vuexState() {
      return this.$store.state.presets;
    },
    range() {
      return this.$store.state.deals.range;
    },
    displayDeallistFilter() {
      let ret = [];
      this.finalFilter.forEach((filterItem) => {
        filterItem.display_values.forEach((value) => {
          ret.push(filterItem.filter.display_name + ': ' + value);
        })
      })
      return ret;
    },
    selectedFilter() { //for Deallist
      return this.$attrs.onlyArchived ? this.$store.state.deallist.selectedFilterArchived : this.$store.state.deallist.selectedFilter;
    },
    finalFilter() { //for Deallist
      return this.$attrs.onlyArchived ? this.$store.state.deallist.finalFilterArchived : this.$store.state.deallist.finalFilter;
    },
  },
  methods: {
    async getDeals(url = '', noPrefix = false) {
      try {
        // this.loadingCount++;
        if (!this.loading) {
          this.dataLoading = true;
        }
        this.dataLoadingCount++;
        if (this.saveSearch) {
          this.tableData.search = this.$store.state.deals.search;
        }
        this.tableData.draw++;
        this.tableData.displayColumns = this.columns;
        this.tableData.deallistFilter = this.selectedFilter ?? null;

        this.tableData.statusFilter = this.statusFilter;
        this.tableData.preset = this.preset;
        this.tableData.presetColumns = this.$store.state.presets.tmpFilterData ? this.$store.state.presets.tmpFilterData : this.$store.state.presets.currentPresetColumns;
        if (!(this.range && Object.keys(this.range).length === 0 && this.range.constructor === Object)) {
          this.tableData.dates = this.range;
        } else {
          this.tableData.dates = null;
        }
        this.tableData.route = this.$route.name;
        // eslint-disable-next-line no-undef
        this.tableData.user = sso.getSsoUser();
        let index = this.getIndex(this.columns, 'name', this.sortKey);
        if (index === -1) {
          let revIndex = this.getIndex(this.columns, 'name', 'brutto_revenue');
          this.tableData.column = revIndex !== -1 && !(revIndex > (this.columns.length - 1)) ? revIndex : 0;
          this.sortKey = revIndex !== -1 && !(revIndex > (this.columns.length - 1)) ? 'brutto_revenue' : 'status';
        } else {
          this.tableData.column = index;
        }
        const {data} = await DealRepository.get(this.tableData, url, noPrefix);
        this.dataLoadingCount--;
        if (this.tableData.draw == data.draw) {
          if (typeof data.data !== 'undefined' && typeof data.data.data !== 'undefined') {
            this.deals = data.data.data;
            this.configPagination(data.data.pagination);
          }
          this.loading = false;
          if (this.dataLoadingCount === 0) {
            this.dataLoading = false;
          }
        }
      } catch (e) {
        console.log(e);
        this.dataLoadingCount--;
        this.loading = false;
        if (this.dataLoadingCount === 0) {
          this.dataLoading = false;
        }
      }
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.callFunction(this.data)
    },
    getIndex(array, key, value) {
      return array.findIndex(i => i[key] == value)
    },
    callFunction(function_name, param = null) {
      if (param) {
        this[function_name](param);
      } else {
        this[function_name]();
      }
    },
    emitRowClicked(data) {
      this.$emit('rowClicked', data);
    },
    search() {
      this.loading = true;
      this.callFunction(this.data)
    },
    handleInput({target}) {
      if (this.saveSearch) {
        this.$store.commit('deals/setSearch', target.value);
      }
      if (this.data === 'getDeals') {
        if (this.$route.name === 'deals') {
          sessionStorage.setItem('tableFilterAll', target.value);
        } else if (this.$route.name === 'mydealsall') {
          sessionStorage.setItem('tableFilterMy', target.value);
        } else if (this.$route.name === 'mydeals') {
          sessionStorage.setItem('tableFilterPreset', target.value);
        }
      }
      this.search();
    },
    updateRange() {
      this.getDeals();
    },
    reload() {
      this.key++;
      this[this.data]();
    },
    filterStatus(filter) {
      this.statusFilter = filter;
      this.getDeals();
    },
    identicalArrays(array1, array2) {
      const array2Sorted = array2.slice().sort();
      return array1.length === array2.length && array1.slice().sort().every(function (value, index) {
        return value.label === array2Sorted[index].label &&
          value.name === array2Sorted[index].name &&
          value.width === array2Sorted[index].width;
      });
    },
    fetchItems(sessionStorageItem) {
      this.tableData.search = sessionStorageItem && typeof sessionStorageItem !== 'undefined' ? sessionStorageItem : '';
    },
    async getDeallist(params = false) {
      await this.getDeals(params ? params : '/deallist', true);
    },
    async getArchivedDeallist(params = false) {
      await this.getDeals(params ? params + '&archived=1' : '/deallist?archived=1', true);
    },
    setCBXall(value) {
      this.cbx_all = value;
      this.$emit('allChecked', this.cbx_all);
    },
    filterValueDeleted(value, filterItem) {
      let tmpFilter = JSON.parse(JSON.stringify(this.selectedFilter));
      let tmpFilterItem = tmpFilter.find(x => x.filter.name === filterItem.filter.name);
      let valueIndex = tmpFilterItem.display_values.findIndex(x => x === value);
      tmpFilterItem.values.splice(valueIndex, 1);
      tmpFilterItem.display_values.splice(valueIndex, 1);

      if (tmpFilterItem.values.length === 0) {
        tmpFilter.splice(tmpFilter.findIndex(x => x.filter.name === tmpFilterItem.filter.name), 1);
      }
      this.$store.commit('deallist/updateSelectedFilter', {
        data: tmpFilter,
        archived: this.$attrs.onlyArchived
      });
      this.$store.commit('deallist/updateFinalFilter', {
        data: tmpFilter,
        archived: this.$attrs.onlyArchived
      });
      this.reload();
    },
  },
  watch: {
    preset() {
      this.reload();
    },
    searchData() {
      this.reload();
    },
    columns(old, newValue) {
      if (JSON.stringify(old) !== JSON.stringify(newValue)) {
        this.reload();
      }
    }
  }
};
</script>

<style scoped lang="scss">

.deals {
  position: relative;
}

input {
  min-height: 40px;
  border: 1px solid #d0d4da;
  background: #fff;
  padding: .5rem;
  display: inline-block;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  font-size: 1em;
}

select {
  font-size: 1em;
  min-height: 40px;
  border: 1px solid #d0d4da;
  padding: .5rem;
  display: inline-block;
}

.control {
  display: inline-block;
  margin-right: 1rem;
}

.tableFilters {
  width: 100%;
  display: inline-block;
  background: #fff;
  padding: 10px 180px 10px 10px;
  margin-bottom: 10px;
}

*:focus {
  outline: none;
}

.loaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 10em;
}

.loader {
  position: relative;
  height: 20px;
  width: 20px;
  display: inline-block;
  animation: around 5.4s infinite;
}

@keyframes around {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

.loader::after, .loader::before {
  content: "";
  background: white;
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-color: #d0d4da #d0d4da transparent transparent;
  border-style: solid;
  border-radius: 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  animation: around 0.7s ease-in-out infinite;
}

.loader::after {
  animation: around 0.7s ease-in-out 0.1s infinite;
  background: transparent;
}

.icon-container {
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
}

.inputcontainer {
  position: relative;
  display: inline-block;
}

.table {
  overflow-x: scroll;
}

:deep( td.action ){
  text-align: right;
  padding-right: 20px;

  .icon {
    font-size: 20px;

    &:not(:first-child) {
      margin-left: 10px;
    }
  }
}

.mobileStatusFilter {
  margin-bottom: 1rem;
  background: #fff;
  margin-top: -1rem;
  padding-bottom: 1rem;
  padding-top: 1rem;
}

@media (max-width: 767px) {
  .inputcontainer {
    margin-top: 1rem;
  }

}

@media (min-width: 1025px) {
  .control {
    margin-bottom: 1rem;
  }
  .filtersInner {
    margin-bottom: -1rem;
  }

}

.row {
  display: flex;
  flex-flow: row;
  margin-bottom: 0.4rem;

  > div, .floating.border {
    width: 100% !important;

    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
}

:deep( .button_container ){
  display: flex;
  flex-flow: row;
  margin-bottom: 1em;
  justify-content: flex-end;

  button {
    height: 2.2em;
  }
}

.deallistFilter :deep( .infoBubble ){
  word-break: break-all;
}
</style>